module.exports = [
	{
		"data": "featured",
		"title": "Featured Customer Stories",
		"customers": [
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-schneider-electric-475741417f.png",
				"text": "Schneider Electric: Streamlining Identity Management",
				"websiteUrl": "http://www.schneider-electric.com/",
				"caseStudyUrl": "https://auth0.com/learn/schneider-electric-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-jet-privilege-9c95f9f445.png",
				"text": "JetPrivilege: SSO Makes For A Seamless Travel Experience",
				"websiteUrl": "https://www.jetprivilege.com/",
				"caseStudyUrl": "https://auth0.com/learn/jetprivilege-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-safari-books-9c1fa82cf7.svg",
				"text": "Safari: Auth0 SSO Drives B2B Expansion",
				"websiteUrl": "https://www.safaribooksonline.com/",
				"caseStudyUrl": "https://auth0.com/learn/safari-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-harvard-medical-school-a8eadc1508.svg",
				"text": "Harvard Medical School: Identity Secures NIH Research",
				"websiteUrl": "https://undiagnosed.hms.harvard.edu/",
				"caseStudyUrl": "https://auth0.com/learn/harvard-medical-school-identity-secures-nih-research/",
				"videoURL": "//fast.wistia.net/embed/iframe/6gehzyd3w0?popover=true",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-marks-spencer-44f43eadfb.svg",
				"text": "Marks & Spencer: Auth0 Authentication Scalability In Action",
				"websiteUrl": "http://www.marksandspencer.com/",
				"caseStudyUrl": "https://auth0.com/learn/marks-spencer-auth0-authentication-scalability-in-action/",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-bluetooth-sig-167197fc93.svg",
				"text": "Bluetooth Special Interest Group (SIG) Case Study",
				"websiteUrl": "https://www.bluetooth.com/",
				"caseStudyUrl": "https://auth0.com/learn/bluetooth-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-battlefy-eef926a7fa.svg",
				"text": "Battlefy: Solves Identity Management and Secures Consumer Data with Auth0",
				"websiteUrl": "https://www.battlefy.com",
				"caseStudyUrl": "https://auth0.com/learn/battlefy-solves-identity-management-with-auth0",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-giving-compass-6fb0d81eb3.svg",
				"text": "Giving Compass Uses Auth0 to Make Philanthropy Easier",
				"websiteUrl": "https://givingcompass.org/",
				"caseStudyUrl": "https://auth0.com/learn/giving-compass-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-nandos-3b7a7239bf.svg",
				"text": "Nando's: Centralizing Identity and Access Management with Auth0",
				"websiteUrl": "https://www.nandosperiperi.com/",
				"caseStudyUrl": "https://auth0.com/learn/nandos-case-study/",
				"color": "#f8f8f8"
			}
		]
	},
	{
		"data": "logistics",
		"title": "Logistics",
		"customers": [
			{
				"hashName": "aeromexico",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-aeromexico-8fafadbb79.svg",
				"text": "Aeromexico is Mexico's global airline. Operating more than 600 flights daily with hubs at the Mexico City International Airport and at the Monterrey International Airport.",
				"websiteUrl": "http://aeromexico.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-freeformers-56fbe7cd4e.png",
				"text": "Freeformers helps transform some of the world's biggest companies for the digital age through exciting, hands-on workshops for everyone.",
				"websiteUrl": "https://freeformers.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-stage-3-f440e9cd52.png",
				"text": "Stage 3 Systems has supported the shipping industry with easy-to-use, secure, common-sense software solutions for their information technology needs for more than a decade.",
				"websiteUrl": "http://stage3systems.com/"
			}
		]
	},
	{
		"data": "healthcare",
		"title": "Healthcare",
		"customers": [
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-fmi-c4143446ab.png",
				"text": "The Friedrich Miescher Institute for Biomedical Research (FMI), based in Basel, Switzerland, is a world class center for basic research in life sciences and part of the Novartis Research Foundation.",
				"websiteUrl": "http://www.fmi.ch"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-zyto-96395af4f4.jpg",
				"text": "ZYTO is a global technology company that creates interfaces between the human body and digital technology to provide insights into personal health and wellness decisions.",
				"websiteUrl": "http://www.zyto.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-SIB-3b5f00fb7f.png",
				"text": "The Swiss Institute of Bioinformatics is a world-renowned scientific consortium of research groups from both universities and the Swiss Federal Institutes of technology.",
				"websiteUrl": "http://www.isb-sib.ch"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-bloodhub-18d512f627.png",
				"text": "BloodHub is a SaaS solution for the medical industry, simplifying the management of blood supplies.",
				"websiteUrl": "http://www.bloodhub.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-wellintune-e7f96c1b7d.png",
				"text": "Wellintune is a comprehensive health management service and online platform that allows companies, individuals, and communities alike grow to be healthier.",
				"websiteUrl": "https://www.attunelife.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-kyruus-26745ff52c.png",
				"text": "Kyruus is an enterprise healthcare provider solutions company that helps to optimize Patient Access, Referral Management, and Care Coordination operations.",
				"websiteUrl": "http://www.kyruus.com/"
			}
		]
	},
	{
		"data": "energy",
		"title": "Energy",
		"customers": [
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-sinopec-34e9bfdae6.svg",
				"text": "Sinopec Limited's parent, Sinopec Group, is one of the major State Owned petroleum energy and chemicals companies in China.",
				"websiteUrl": "http://english.sinopec.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-canem-6726855d7d.png",
				"text": "Canem, Ltd. is a Canadian firm specializing in electrical contracting.",
				"websiteUrl": "http://www.canem.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-tachyus-79eb52b588.png",
				"text": "Tachyus creates technology to optimize energy production for the oil and gas industry.",
				"websiteUrl": "http://www.tachyus.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-agl-d2bf7e9454.png",
				"text": "AGL is one of Australia's leading integrated energy companies and largest ASX listed owner, operator and developer of renewable energy generation in the country.",
				"websiteUrl": "http://www.agl.com.au"
			}
		]
	},
	{
		"data": "media",
		"title": "Media",
		"customers": [
			{
				"hashName": "PBS",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-pbs-f8e4a8a436.svg",
				"text": "PBS is an independently operated non-profit organization and is the most prominent provider of television programs to public television stations in the United States.",
				"websiteUrl": "http://www.pbs.org/"
			},
			{
				"hashName": "newscorp",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-newscorp-0dab593d7b.svg",
				"text": "News Corp is a network of leading companies in the worlds of diversified media, news, education, and information services.",
				"websiteUrl": "http://www.newscorp.com/"
			},
			{
				"hashName": "harper",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-harper-2aa0adbdf2.png",
				"text": "HarperCollins Publishers LLC is one of the world's largest publishing companies and is part of the 'Big Five' English-language publishing companies.",
				"websiteUrl": "http://www.harpercollins.com/"
			},
			{
				"hashName": "houghton-mifflin-harcourt",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-houghton-mifflin-harcourt-480a734da6.png",
				"text": "Houghton Mifflin Harcourt is a global learning company dedicated to changing people’s lives by fostering passionate, curious learners.",
				"websiteUrl": "http://www.hmhco.com/"
			},
			{
				"hashName": "dow-jones",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-dow-jones-938692c0f5.png",
				"text": "Dow Jones & Company is an American publishing and financial information firm. Dow Jones has grown to be a worldwide news and information powerhouse.",
				"websiteUrl": "http://www.dowjones.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-music-memory-48c4e23a3a.jpg",
				"text": "MUSIC & MEMORY℠ is a non-profit organization that brings personalized music into the lives of the elderly or infirm, vastly improving quality of life.",
				"websiteUrl": "http://musicandmemory.org/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-cm-group-79854a1318.png",
				"text": "CM Group is a leader in delivering eLearning and mobile learning to major companies worldwide. ",
				"websiteUrl": "http://www.cm-group.co.uk"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-fubotv-c9188e94f2.png",
				"text": "fuboTV is a streaming TV service offering the best live soccer coverage 24x7. Featuring sports and entertainment programming.",
				"websiteUrl": "http://www.fubo.tv"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-plan-3-e10b95f461.png",
				"text": "Plan 3 consists in a diverse set of professionals creating streamlined services that leverage the latest in know-how. ",
				"websiteUrl": "http://plan3.se/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-medvid-018a3ac172.png",
				"text": "medvid.io powers HIPAA Compliant Video Management and transforms the Doctor – Patient Relationship, One Video at a Time.",
				"websiteUrl": "https://reeldx.com/medvidio/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-infomedia-e754c538bd.png",
				"text": "Infomedia is a worldwide leader in SaaS automotive parts and service systems which empower their dealer customers to deliver a superior service level.",
				"websiteUrl": "http://www.infomedia.com.au"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-coleman-60eee462de.png",
				"text": "Coleman Insights is a firm that has has helped media properties build strong brands and develop great content since 1978.",
				"websiteUrl": "http://www.colemaninsights.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-southcomm-d5c3a23ccd.png",
				"text": "SouthComm is the nation’s second largest publisher of alternative weeklies. The company owns more than 30 titles targeting B2B and audiences around the country.",
				"websiteUrl": "http://www.southcomm.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-kinesis-67f497a3b7.png",
				"text": "Kinesis provides pragmatic and evidence based solutions to the climate problem. , It’s mission is to make organizations and cities more resilient, productive and sustainable.",
				"websiteUrl": "http://www.kinesis.org/"
			},
			{
				"hashName": "kodak",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/kodak-a4daeeea12.png",
				"text": "The Eastman Kodak Company (referred to simply as Kodak) is an American technology company that produces imaging products with its historic basis on photography.",
				"websiteUrl": "http://www.kodak.com"
			}
		]
	},
	{
		"data": "financial",
		"title": "Financial Services",
		"customers": [
			{
				"hashName": "financial-times",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-financial-times-974fd8fe13.svg",
				"text": "The Financial Times is one of the world’s leading business news organisations, recognised internationally for its authority, integrity and accuracy.",
				"websiteUrl": "https://www.ft.com/"
			},
			{
				"hashName": "berkshire",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-bhtp-24dd312f64.png",
				"text": "As Berkshire Hathaway’s travel insurance arm, BHTP gives travelers the coverage they need in simpler and smarter ways than ever before.",
				"websiteUrl": "https://www.bhtp.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-sancor-476526c5b2.png",
				"text": "Grupo Sancor Seguros is the premier Insurance Group in Argentina and a market leader across Latin America.",
				"websiteUrl": "https://www.gruposancorseguros.com/en"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-concierge-auctions-4ba2c06afb.png",
				"text": "Concierge Auctions is an innovative, online luxury real-estate auction house. A win-win for sellers, buyers, and agents alike.",
				"websiteUrl": "http://www.conciergeauctions.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-advance-041d77a779.png",
				"text": "AdvancedREI is Deal Intelligence for Commercial Real Estate. It delivers advanced predictive analysis and insights to today's commercial real estate professionals.",
				"websiteUrl": "http://advancedrei.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-notient-454a3cd3b7.png",
				"text": "Notient automates and aggregates peer-to-peer investments. Their system allows the novice or hands-off investor to be up and running with Notient in only a few clicks.",
				"websiteUrl": "https://notient.com/#!/aboutus"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-simpology-4482cd5a45.png",
				"text": "Simpology is an Australia-based software company delivering powerful solutions for originating and processing loan applications.",
				"websiteUrl": "http://www.simpology.com.au"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-nickel-swan-89c04f2aed.svg",
				"text": "Nickel & Swan offers a revolutionary equity option analytics platform to help optimize option trades, understand option data, and feel the market pulse.",
				"websiteUrl": "http://www.nickelandswan.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-spv-24dc83a579.jpg",
				"text": "Sparebanken Vest, established in 1823, is Norway's third largest bank, and a financial services leader in Western Norway. With a focus on both private and corporate banking, Sparebanken Vest is committed to Norway's social and commercial development.",
				"websiteUrl": "https://www.spv.no/"
			}
		]
	},
	{
		"data": "retail",
		"title": "Retail",
		"customers": [
			{
				"hashName": "nandos",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-nandos-3b7a7239bf.svg",
				"text": "Nando's is an international casual dining restaurant chain originating from South Africa, with a Mozambican/Portuguese theme. Founded in 1987, Nando's operates about 1,000 outlets in 30 countries.",
				"websiteUrl": "http://www.nandos.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-russell-cellular-275eceda95.jpg",
				"text": "Russell Cellular is a Verizon Premium Retailer operating in the midwest and southern USA. Founded in 1993, Russell Cellular has over 250 retail locations in 22 states.",
				"websiteUrl": "http://www.russellcellular.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-collect-d72467ae98.png",
				"text": "Collect.it is a social community and marketplace serving the multi-billion dollar collectibles market.",
				"websiteUrl": "http://collect.it/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-redicarpet-283973ceb4.png",
				"text": "Redi Carpet is one of the largest flooring suppliers to the apartment industry. The company offers next day flooring installation for multi-family apartments and homes.",
				"websiteUrl": "http://www.redicarpet.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-krrb-e97702968e.jpg",
				"text": "Krrb is a local classifieds, connecting your community with other communities around the world.",
				"websiteUrl": "https://krrb.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-directlease-8147dd9f60.png",
				"text": "DirectLease group is an online car lease company for Dutch, Belgian and German customers.",
				"websiteUrl": "http://directlease.nl/DLNl/home.do"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-casestack-6b7bd00306.png",
				"text": "CaseStack is a leading logistics provider that specializes in applying efficient and sustainable supply chain solutions, including warehousing and transportation.",
				"websiteUrl": "https://ww2.casestack.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-foodjunky-c6c95de0d7.png",
				"text": "Foodjunky is an online platform for ordering food. It makes the process easy for individuals, groups, and catering, so everyone's happy.",
				"websiteUrl": "http://www.foodjunky.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-clowder-985e90b089.svg",
				"text": "Clowder is premium coffee brewed and delivered to customers door within 15 minutes. Offices in NYC and Mountain View.",
				"websiteUrl": "https://www.clowder.nyc/"
			}
		]
	},
	{
		"data": "manufacturing",
		"title": "Manufacturing",
		"customers": [
			{
				"hashName": "polaris",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-polaris-industries-14027da178.svg",
				"text": "Polaris Industries is a global leader in the off-road consumer and millitary markets.",
				"websiteUrl": "http://www.polaris.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-coop-tender-43a59c4b0e.png",
				"text": "Coop Tender ™ Internet Wi-Fi Enabled Automatic Chicken Coop Door takes the hassles out of raising free-range chickens.",
				"websiteUrl": "http://cooptender.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/mazda-16608cbd9f.svg",
				"text": "Mazda Motor Corporation, commonly referred to as simply Mazda, is a Japanese multinational automaker based in Fuchū, Aki District, Hiroshima Prefecture, Japan.",
				"hashName": "mazda",
				"websiteUrl": "https://www.mazdausa.com"
			},
			{
				"hashName": "siemens",
				"text": "Siemens is the largest industrial manufacturing company in Europe with branch offices abroad.",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/siemens-8ffb299c85.png",
				"websiteUrl": "http://www.siemens.com"
			}
		]
	},
	{
		"data": "software",
		"title": "Software / Design",
		"customers": [
			{
				"hashName": "atlassian",
				"img": "https://cdn.auth0.com/website/auth0-sources/logos/atlassian-horizontal-blue-rgb.svg",
				"text": "Atlassian is a group of enterprise software companies that develops products for software developers, project managers, and content management.",
				"websiteUrl": "https://www.atlassian.com/"
			},
			{
				"hashName": "mozilla",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-mozilla-c391653364.svg",
				"text": "Mozilla is a technology not-for-profit dedicated to ensuring the Internet is a global public resource, open and accessible to all.  We do that by building products, technologies and programs that put people in control of their online lives.",
				"websiteUrl": "https://www.mozilla.org"
			},
			{
				"hashName": "vmware",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/vmware-a8e96de0b1.jpg",
				"text": "VMware is a subsidiary of Dell Technologies that provides cloud computing and platform virtualization software and services. It was the first commercially successful company to virtualize the x86 architecture.",
				"websiteUrl": "https://www.vmware.com"
			},
			{
				"hashName": "nvidia",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-nvidia-1431159d4a.svg",
				"text": "NVIDIA is the world leader in visual computing. The GPU, their invention, serves as the visual cortex of modern computers and is at the heart of their products and services.",
				"websiteUrl": "https://www.nvidia.com/"
			},
			{
				"hashName": "bluetooth-sig",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-bluetooth-sig-167197fc93.svg",
				"text": "The Bluetooth SIG is the body that oversees the development of Bluetooth standards and the licensing of the Bluetooth technologies and trademarks to manufacturers.",
				"websiteUrl": "http://www.bluetooth.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-redsequence-fefaf396fa.png",
				"text": "Red Sequence was founded in 2013, in order to develop cloud productivity apps for individuals and teams. It’s currently extending its application, Timestamp.",
				"websiteUrl": "http://www.redsequence.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-zudio-43d5c53d62.png",
				"text": "With Zudio, you can manage your Windows Azure Storage wherever you are, on any device with a modern web browser, no artificial licence restrictions.",
				"websiteUrl": "https://zud.io/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-giant-machines-88a3e335cb.png",
				"text": "Giant Machines authors custom software for companies large and small by providing consulting services to fit their customer’s needs.",
				"websiteUrl": "http://giantmachines.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-fadeit-99b78be66c.svg",
				"text": "Fadeit is a software development company with expertise in a wide variety of IT subjects such as Internet of Things, Distributed Systems, Open Data, and more.",
				"websiteUrl": "http://fadeit.dk/da"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-performant-63fcc1e99a.png",
				"text": "Performant Software Solutions partners with researchers, scholars and entrepreneurs to create web and mobile software that educates, enriches and entertains.",
				"websiteUrl": "http://www.performantsoftware.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-contemplor-5798bccfa0.png",
				"text": "Contemplor Software has developed modeling and work product automation tools that revolutionize business.",
				"websiteUrl": "http://contemplorsoftware.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-dragonfly-80972445d8.png",
				"text": "Dragonfly Design Group provides graphic design and various services for PR firms, marketing consultants, entrepreneurs and even in-house art departments.",
				"websiteUrl": "http://dragonflydg.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-identillect-188d4c70cb.png",
				"text": "Identillect Technologies is an innovative email security company with a proprietary email encryption technology targeted at organizations, as well as individuals.",
				"websiteUrl": "https://identillect.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-kiosk-browser-cd5f44eaa0.png",
				"text": "Kiosk Browser has been designed for use on any android device and is great for creating public kiosks, interactive digital signage etc.",
				"websiteUrl": "http://www.android-kiosk.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-trueflow-5bc79d0c63.png",
				"text": "TrueFlow is changing the way venues engage with users indoors using sensors, wifi and other radio signals within the venue, resulting in greater engagement.",
				"websiteUrl": "http://www.trueflow.io/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-stonetip-a5768a281a.png",
				"text": "Stonetip specializes in mobile app development, with apps that are aimed at mapping, productivity and fitness.",
				"websiteUrl": "http://code.stonetip.com/about/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-mindjet-b5fc05d718.png",
				"text": "Mindjet is a collaborative work management software Mindjet's software products, are designed to visually and collaboratively manage information and tasks.",
				"websiteUrl": "https://www.mindjet.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-trading-work-9f348c0a85.png",
				"text": "TradingWorks ensure their customers understand how their resources are being utilized and provide real time data to help them to maximize efficiency and results.",
				"websiteUrl": "http://www.tradingworks.com.br/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-sapho-0c16f30d63.png",
				"text": "Sapho provides an enterprise software platform for organizations to offer access to corporate information on mobile devices by utilizing software APIs.",
				"websiteUrl": "http://www.sapho.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-gridvision-a903a351b2.png",
				"text": "GridVision transforms IT by automating and eliminating repetitive, mundane and complex activities such as monitoring computer systems and applications.",
				"websiteUrl": "http://www.grid-vision.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-agrippa-bdd593c05a.png",
				"text": "Agrippa Solutions provides services for project management, change management, enterprise architecture, quality assurance and other facets of IT.",
				"websiteUrl": "https://agrippa.azurewebsites.net/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-blinkmobile-d87ec79257.jpg",
				"text": "BlinkMobile helps organizations more easily harness mobile and emerging technologies to quickly and securely extend their core business systems.",
				"websiteUrl": "http://blinkmobile.com.au/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-candoris-e399aa9846.png",
				"text": "Candoris is an IT Systems Integration firm focused on implementing technology that increases the efficiency of businesses.",
				"websiteUrl": "http://www.candoris.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-timestamp-50e40caa39.png",
				"text": "Timestamp is a time tracking application that will help you discover in what you consume your time.",
				"websiteUrl": "http://www.timestamphq.com/"
			},
			{
				"hashName": "amd",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-amd-1d53131816.svg",
				"text": "Advanced Micro Devices, Inc. (AMD) is an American multinational semiconductor company based in Sunnyvale, California, United States, that develops computer processors and related technologies for business and consumer markets.",
				"websiteUrl": "http://www.amd.com/"
			}
		]
	},
	{
		"data": "online-services",
		"title": "Online Services / Analytics",
		"customers": [
			{
				"hashName": "optimizely",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-optimizely-1452715a9c.svg",
				"text": "Optimizely is the world’s leading experimentation platform, enabling businesses to deliver continuous experimentation and personalization across websites, mobile apps and connected devices.",
				"websiteUrl": "https://www.optimizely.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-purestorage-4ad004d5af.svg",
				"text": "Pure Storage is an all-flash enterprise storage company that delivers high performance solutions for data centers, cloud computing, Big Data and real-time analytics.",
				"websiteUrl": "http://www.purestorage.com/"
			},
			{
				"hashName": "tableau",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/tableau-a5a0f3b9a2.png",
				"text": "Tableau Software is a software company headquartered in Seattle, Washington, United States which produces interactive data visualization products focused on business intelligence.",
				"websiteUrl": "https://www.tableau.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-cymbalstream-1cb5409591.png",
				"text": "Cymbalstream delivers what others only talk about – rapid ROI, effective optimization and tools to manage your IT without the typical administrative overhead and cost.",
				"websiteUrl": "http://www.cymbalstream.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-blueip-4371013b94.jpg",
				"text": "BluIP is a leading wholesale provider of cloud-based voice technology. They deliver mission-critical products engineered for the SMB and LE Markets.",
				"websiteUrl": "http://www.bluip.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-ire-684c78cc1e.png",
				"text": "Ireckon uses their expertise to create powerful software solutions that solve business needs, on time and on budget. ",
				"websiteUrl": "http://www.ireckon.nl/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-10th-magnitude-7683331c00.svg",
				"text": "10th Magnitude, one of the top Microsoft Azure services firms in the US, provides customers with a full suite of cloud services.",
				"websiteUrl": "http://www.10thmagnitude.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-bang-the-table-088186a181.jpg",
				"text": "Bang the Table delivers world-class interactive communications solutions branded with their client's identity.",
				"websiteUrl": "http://www.bangthetable.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-my-objectives-05a4540825.png",
				"text": "MyObjectives is performance management solution that is a low cost, SaaS solution that allows organizations of all sizes to implement Management by Gaming.",
				"websiteUrl": "http://www.allianceenterprises.com/myobjectives"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-westat-38351a91d5.png",
				"text": "Westat, Inc. specializes in executing non-partisan, scientifically valid research studies for a broad range of  organizations.",
				"websiteUrl": "http://www.westat.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-rapidminer-18156ec3e2.png",
				"text": "RapidMiner is an open source, predictive analytics platform that lets analysts quickly uncover opportunities and risks, and guide business decision.",
				"websiteUrl": "http://www.rapidminer.com/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-moving-8962eea41d.png",
				"text": "Machine to Machine (M2M) Services. Data Mining and Business Intelligence. Ericsson Authorised Service Partner.",
				"websiteUrl": "http://movingdata.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-peruse-efa3400a99.png",
				"text": "Peruse.io is pioneering a new way to get answers to questions about your documents.",
				"websiteUrl": "https://peruse.io/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-datastreamx-7995e7b992.svg",
				"text": "DataStreamX is a data marketplace for real-time data created from IoT, M2M and Big Data Applications.",
				"websiteUrl": "https://www.datastreamx.com/"
			},
			{
				"hashName": "teradata",
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/teradata-79f3c51f53.jpg",
				"text": "Teradata Corporation is a provider of database-related products and services. The company was formed in 1979 in Brentwood, California, as a collaboration between researchers at Caltech and Citibank's advanced technology group.",
				"websiteUrl": "http://www.teradata.com"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-42-6332197564.png",
				"text": "42 is a predictive analytics platform for retailers. 42 works with some of the world's best known brands and is backed by Y Combinator.",
				"websiteUrl": "https://42technologies.com/#/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-satalyst-5fc1de5261.png",
				"text": "Satalyst is focused on delivering high quality project based IT solutions and assists companies to realise the business benefits technology can offer.",
				"websiteUrl": "https://www.clowder.nyc/"
			},
			{
				"img": "https://cdn.auth0.com/website/assets/pages/customers/img/logo-salt-a3a453f9d0.svg",
				"text": "Salt provides a services that help customers build powerful datasets. They focus on turning big data into small data that is accessible, understandable, and actionable.",
				"websiteUrl": "http://salt.io/"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/customers/customers.json
// module id = 1376
// module chunks = 0